import { mapGetters } from 'vuex'

export const authorizeMixin = {
  computed: {
    ...mapGetters(['authorize', 'authorizeBool'])
  }
}
